module.exports = __webpack_public_path__ + "media/assets/badges/WADLINE-818a758b579d41b02bad44954dea06c1.svg";